<template>
  <div>
    <!-- Job Single Content Starts -->
    <section class="job-single-content section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="jobs-tab tab-item">
              <ul>
                <li class="active">recent</li>
                <li>full time</li>
                <li>part time</li>
                <li>intern</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="main-content">
              <div class="single-content1">
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>Assistant Executive - Production/ Quality Control</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job1.png" alt="job">
                  </div>
                </div>
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>Asst. Manager, Production (Woven Dyeing)</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job2.png" alt="job">
                  </div>
                </div>
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>Deputy Manager/ Assistant Manager - Footwear</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job3.png" alt="job">
                  </div>
                </div>
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>R&D Manager (Technical Lab Department)</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job4.png" alt="job">
                  </div>
                </div>
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>Manager/ Asst. Manager (Quality Assurance)</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job5.png" alt="job">
                  </div>
                </div>
                <div class="single-job d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>Deputy Manager/ Assistant Manager - Footwear</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job3.png" alt="job">
                  </div>
                </div>
              </div>
            </div>
            <div class="more-job-btn mt-5 text-center">
              <a href="#" class="template-btn">more job post</a>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="sidebar mt-5 mt-lg-0">
              <div class="single-item mb-4">
                <h4 class="mb-4">jobs type</h4>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Full Time</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Part Time</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between">
                  <span>Internship</span>
                  <span class="text-right">25 job</span>
                </a>
              </div>
              <div class="single-item mb-4">
                <h4 class="mb-4">job by location</h4>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>New York</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>California</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Swizerland</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>Canada</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between">
                  <span>Sweden</span>
                  <span class="text-right">25 job</span>
                </a>
              </div>
              <div class="single-item mb-4">
                <h4 class="mb-4">salary range</h4>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>$20,000-$30,000</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between mb-3">
                  <span>$25,000-$45,000</span>
                  <span class="text-right">25 job</span>
                </a>
                <a href="#" class="sidebar-btn d-flex justify-content-between">
                  <span>$40,000-$70,000</span>
                  <span class="text-right">25 job</span>
                </a>
              </div>
              <div class="single-item">
                <h4 class="mb-4">filter by salary</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Job Single Content End -->


    <!-- Newsletter Area Starts -->
    <section class="newsletter-area job-single section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>Get job information daily</h2>
              <p>Subscribe to our newsletter and get a coupon code!</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <form action="#">
              <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Your email here'" required>
              <button type="submit" class="template-btn">subscribe now</button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <!-- Newsletter Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// JobCategory.vue?6a545170